/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ScriptSection } from './ScriptSection.js';
import {
    ScriptSectionFromJSON,
    ScriptSectionFromJSONTyped,
    ScriptSectionToJSON,
} from './ScriptSection.js';

/**
 * 
 * @export
 * @interface Script
 */
export interface Script {
    /**
     * 
     * @type {number}
     * @memberof Script
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Script
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof Script
     */
    chapterCount?: number;
    /**
     * 
     * @type {Date}
     * @memberof Script
     */
    dateCreated?: Date;
    /**
     * 
     * @type {Array<string>}
     * @memberof Script
     */
    text?: Array<string>;
    /**
     * 
     * @type {Array<ScriptSection>}
     * @memberof Script
     */
    sections?: Array<ScriptSection>;
}

/**
 * Check if a given object implements the Script interface.
 */
export function instanceOfScript(value: object): boolean {
    return true;
}

export function ScriptFromJSON(json: any): Script {
    return ScriptFromJSONTyped(json, false);
}

export function ScriptFromJSONTyped(json: any, ignoreDiscriminator: boolean): Script {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'chapterCount': json['chapterCount'] == null ? undefined : json['chapterCount'],
        'dateCreated': json['dateCreated'] == null ? undefined : (new Date(json['dateCreated'])),
        'text': json['text'] == null ? undefined : json['text'],
        'sections': json['sections'] == null ? undefined : ((json['sections'] as Array<any>).map(ScriptSectionFromJSON)),
    };
}

export function ScriptToJSON(value?: Script | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'chapterCount': value['chapterCount'],
        'dateCreated': value['dateCreated'] == null ? undefined : ((value['dateCreated']).toISOString()),
        'text': value['text'],
        'sections': value['sections'] == null ? undefined : ((value['sections'] as Array<any>).map(ScriptSectionToJSON)),
    };
}

